import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import BottomBarMenuItem from './BottomBarMenuItem';
import { HeaderLink, BottomBarProps } from '../Interfaces';
import styles from '../Header.styles';
import { useLocation } from 'react-router-dom';

const BottomBar: React.FC<BottomBarProps> = ({
  menuElements,
}: BottomBarProps) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const renderNavItems = (navItems: HeaderLink[]) => {
    return navItems.map((item, i) => {
      const directMatch = item.url === currentPath;
      const subLinkMatch =
        item.subLinks?.some((sub) => sub?.url?.split('#')[0] === currentPath) ??
        false;

      const isActive = directMatch || subLinkMatch || false;
      return (
        <BottomBarMenuItem
          key={item.label}
          label={item.label}
          url={item.url}
          icon={item.icon}
          subLinks={item.subLinks}
          externalUrl={item.externalUrl}
          index={i}
          isActive={isActive}
        />
      );
    });
  };

  return (
    <>
      <Toolbar
        sx={styles.bottomBar}
        classes={{
          root: 'custom-toolbar',
        }}
      >
        {renderNavItems(menuElements)}
      </Toolbar>
    </>
  );
};

export default BottomBar;
